import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowRoundClockwise24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowRoundClockwise24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M17.736 10.465c-.876-3.272-4.048-5.118-7.312-4.243-3.267.875-5.118 4.081-4.242 7.348.875 3.268 4.081 5.119 7.348 4.243a6.2 6.2 0 0 0 2.388-1.22c.253-.211.435-.402.55-.536q.088-.1.125-.15l.024-.034.003-.004-.001.002.002-.003a.75.75 0 0 1 1.242.841l-.623-.418c.623.418.623.418.622.419l-.001.002-.002.003-.005.007-.016.022-.051.07a5 5 0 0 1-.186.227c-.161.186-.4.434-.72.703a7.7 7.7 0 0 1-2.963 1.518c-4.067 1.09-8.095-1.236-9.185-5.303s1.236-8.096 5.303-9.186c3.455-.926 6.85.612 8.464 3.582V6.75a.75.75 0 0 1 1.5 0V12h-5.25a.75.75 0 0 1 0-1.5h2.997z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowRoundClockwise24);
